
export type Mouse = "Mouse";
export type Keyboard = "Keyboard";
export type TouchScreen = "TouchScreen";

export type InputDeviceType = Mouse | Keyboard | TouchScreen;

/*
matcher: export type \w+ = "\w+";
replace: static readonly $1:$1 = "$2"; 
*/

export class InputDeviceTypes
{  
  static readonly Mouse:Mouse = "Mouse"; 
  static readonly Keyboard:Keyboard = "Keyboard"; 
  static readonly TouchScreen:TouchScreen = "TouchScreen"; 
}